import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Slider,
  Slide,
  CarouselArrowNext,
  CarouselArrowPrev,
  RelativeWrapper,
} from './experienceTestimonials.styles';
import { EntityRefData } from '../../../shared/components/entityRefData';
import { Testimonial } from './testimonial';

export class ExperienceTestimonials extends PureComponent {
  static propTypes = { testimonials: PropTypes.arrayOf(PropTypes.string) };

  render() {
    return (
      <Container>
        <RelativeWrapper>
          <Slider
            arrowPrev={props => <CarouselArrowPrev {...props} />}
            arrowNext={props => <CarouselArrowNext {...props} />}
            options={{
              dots: false,
              autoplay: false,
              arrows: false,
              fade: true,
              speed: 0,
            }}
          >
            {this.props.testimonials.map(testimonialRef => (
              <EntityRefData id={testimonialRef} entityType="testimonials" key={testimonialRef}>
                {testimonial => (
                  <Slide>
                    <Testimonial {...testimonial} />
                  </Slide>
                )}
              </EntityRefData>
            ))}
          </Slider>
        </RelativeWrapper>
      </Container>
    );
  }
}
